import Amplify from "aws-amplify";
import React from "react";
import ReactDOM from "react-dom";
import config from "./aws-exports";
import App from "./App";

console.log(config)
Amplify.configure(config);

ReactDOM.render(<App />, document.getElementById("root"));
